export default {
    homePage: {
        HOME_PAGE_REVALIDATION_SUCCESS: 'Home page successfully revalidated',
        HOME_PAGE_REVALIDATION_ERROR: 'Failed to revalidate home page',
    },
};
